<template>
  <div
    class="rounded-xl p-10 xl:p-6"
    :class="[
      mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100 shadow-primary',
      classes,
    ]"
  >
    <div
      v-if="title"
      class="flex items-center justify-between"
      :class="[isCenter ? 'mb-7 text-center sm:mb-5' : 'mb-5']"
    >
      <div :class="[$slots.actions ? '' : 'w-full flex-1']">
        <h2
          class="font-semibold leading-none sm:text-[18px]"
          :class="[isSmallTitle ? 'text-[22px]' : 'text-[34px] md:text-[22px]']"
        >
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          v-html="subtitle"
          class="mt-4 text-[16px] font-medium md:text-[14px]"
          :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
        />
      </div>
      <slot v-if="$slots.actions" name="actions" />
    </div>
    <slot name="body" />
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    mode: String,
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    isSmallTitle: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
    isCenter: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
